export default __webpack_public_path__ + "static/media/logoEmporio3.aa08c109.png";